export default "__VITE_ASSET__KDweLJmK__"